export function hasDateTimePassed(
  dateTimeStr: string,
  durationInMinutes: number,
): boolean {
  // Parse the input date-time string
  const givenDateTime = new Date(dateTimeStr);

  // Validate if the date is valid
  if (isNaN(givenDateTime.getTime())) {
    throw new Error(
      'Invalid date-time format.',
    );
  }

  // Add duration to the given date-time
  const endDateTime = new Date(
    givenDateTime.getTime() + durationInMinutes * 60000,
  );

  // Compare with current date-time
  const currentDateTime = new Date();

  return currentDateTime > endDateTime;
}
